<app-loading [mosTexto]="true" *ngIf="cargando"></app-loading>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'CONVENIOSPLANESCARGOS.LBL_CONVENIOS' | translate}}</h1>
  </div>
</div>

<div class="grid" *ngIf="!cargando">
  <div class="grid form-group" style="align-items: center; display: flex">
    <div class="col-12 md:col-6 lg:col-6">
      <div class="btn-group" role="group">
        <div class="div-form">
          <button type="button" pButton icon="fa fa-plus" (click)="agregarConvenio()"
                  label="{{ 'BTN_AGREGAR' | translate }}" *ngIf="agregar"></button>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-6" style="display: flex; justify-content: right">
      <div class="div-form col-9 md:col-9 lg:col-9 font-size-adm-preapro">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="dt.filterGlobal($event.target.value, 'contains')" [(ngModel)]="busqueda" (change)="setBusqueda()"/>
      </div>
    </div>
  </div>
</div>

<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carInformacion" #dt [value]="convenioPlanCargo"
             selectionMode="single" dataKey="idHomologacionPlanCargo" [paginator]="true"
             [rows]="regPorPagina"  paginatorPosition="bottom" [globalFilterFields]="filtroBusqueda">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
              class="text-center">
            {{ col.header }}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td class="text-center">{{ row.codigo}}</td>
          <td class="text-center">{{ row.nombre}}</td>
          <td class="text-center">{{ row.descripcion}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                      title="{{ 'BTN_VISUALIZAR' | translate }}" pButton (click)="verDetallleConvenio(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{ 'BTN_EDITAR' | translate }}" pButton [disabled]="!editar"
                      (click)="editarConvenio(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ "MSG_NOHAYREGISTROS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
